// web/src/components/SearchBarDropdown.jsx

import { useEffect, useRef, useState } from "react";

import { useVehicle }
from "../../context/VehicleContext";


const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://eleven11-i6v4.onrender.com";


const BRAND = "#00A6FF";
const APPLE_EASE     = "cubic-bezier(0.4, 0, 0.6, 1)";
const APPLE_EASE_OUT = "cubic-bezier(0.2, 0, 0, 1)";

const RECENTS = [
  { query: "RXP-X 300 Supercharger", location: "Sea-Doo Engine" },
  { query: "SVHO Intake Grate", location: "Yamaha Intake" },
  { query: "Spark Wear Ring", location: "Pump Components" },
];

const NEARBY = [
  { label: "Electrical" },
  { label: "Engine" },
  { label: "Intake" },
  { label: "Exhaust" },
  { label: "Pump" },
  { label: "Plugs" },
  { label: "Reverse" },
  { label: "Steering" },
  { label: "Oil" },
  { label: "Fuel" },
];


const SERVICES = [
  {
    title: "OEM Electrical",
    sub: "Harnesses • Sensors • ECUs",
    bg: "#e8f4fd",
  },

  {
    title: "Performance Intake",
    sub: "Grates • Plates • Filters",
    bg: "#e8fff6",
  },

  {
    title: "Engine Components",
    sub: "Blocks • Pistons • Heads",
    bg: "#fff5e8",
  },

  {
    title: "Maintenance Kits",
    sub: "Oil • Plugs • Filters",
    bg: "#f4ecff",
  },
];

const SUGGESTIONS = [
  "RXP-X 300 Supercharger",
  "Sea-Doo Wiring Harness",
  "Yamaha SVHO Intake Grate",
  "Spark Wear Ring",
  "IBR Control Module",
  "Sea-Doo ECU",
  "RXP Intake Plate",
  "Yamaha Ride Plate",
  "Exhaust Resonator",
  "Pump Rebuild Kit",
];

export default function SearchBarDropdown({ open, onClose, query, onSearch }) {
  const [visible,  setVisible]  = useState(false);
  const [expanded, setExpanded] = useState(false);
  
const [results, setResults] = useState([]);
const [loading, setLoading] = useState(false);

const [featuredListings, setFeaturedListings] = useState([]);

  const panelRef = useRef(null);

const {
  selectedVehicle,
  vehicleLoaded,
} = useVehicle();


  // Open: mount → wait 20ms for paint → expand
  // Close: collapse → wait for transition → unmount
  useEffect(() => {
    if (open) {
      setVisible(true);
      const t = setTimeout(() => setExpanded(true), 20);
      return () => clearTimeout(t);
    } else {
      setExpanded(false);
      const t = setTimeout(() => setVisible(false), 420);
      return () => clearTimeout(t);
    }
  }, [open]);

  // Click outside closes
  useEffect(() => {
    if (!visible) return;
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) onClose();
    };
    setTimeout(() => document.addEventListener("mousedown", handler), 0);
    return () => document.removeEventListener("mousedown", handler);
  }, [visible]);

  // ESC closes
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape" && open) onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);



useEffect(() => {
  if (!query.trim()) {
    setResults([]);
    return;
  }

  const timeout = setTimeout(async () => {
    try {
      setLoading(true);

     let url =
  `${API_URL}/api/listings/search/query?q=${encodeURIComponent(query)}`;

if (selectedVehicle) {

  const params =
    new URLSearchParams({

      manufacturer:
        selectedVehicle.manufacturer,

      model:
        selectedVehicle.model,

      year:
        selectedVehicle.year,

    });

  url += `&${params.toString()}`;
}

const res = await fetch(url);





      const data = await res.json();

      setResults(data || []);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, 250);

  return () => clearTimeout(timeout);

}, [query]);



useEffect(() => {

if (!vehicleLoaded) return;

  const fetchFeaturedListings = async () => {
    try {

   let url =
  `${API_URL}/api/listings`;

if (selectedVehicle) {

  const params =
    new URLSearchParams({

      manufacturer:
        selectedVehicle.manufacturer,

      model:
        selectedVehicle.model,

      year:
        selectedVehicle.year,

    });

  url += `?${params.toString()}`;
}

const res = await fetch(url);

  const data = await res.json();

const universalCategories = [
  "Accessories",
  "Marine Detailing",
  "Lubricants & Sprays",
  "Fluids & Maintenance"
];

const fitmentKey = selectedVehicle
  ? `${selectedVehicle.year} ${selectedVehicle.manufacturer} ${selectedVehicle.model}`
  : null;

const filtered = selectedVehicle

  ? data.filter(listing =>

      universalCategories.includes(
        listing.category
      )

      ||

      listing.compatibleModels?.includes(
        fitmentKey
      )

    )

  : data;

// randomize filtered listings
const shuffled = [...filtered].sort(
  () => 0.5 - Math.random()
);

// take 4
setFeaturedListings(
  shuffled.slice(0, 4)
);

    } catch (err) {
      console.error(err);
    }
  };

  fetchFeaturedListings();

}, [selectedVehicle, vehicleLoaded]);


  if (!visible) return null;

  const handleSearch = (q) => {
    if (!q?.trim()) return;
    onSearch?.(q.trim());
    onClose();
  };





  return (
    <>
{/* ── Curtain ───────────────────────────────────────────────────── */}
<div
  style={{
    position: "fixed",
    inset: 0,

    zIndex: 55,

    background: "rgba(0, 0, 0, 0.28)",

    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",

    opacity: expanded ? 1 : 0,
    visibility: expanded ? "visible" : "hidden",

    transition: expanded
      ? `opacity 0.32s ${APPLE_EASE} 0.08s, visibility 0.32s steps(1,start) 0.08s`
      : `opacity 0.28s ${APPLE_EASE}, visibility 0.28s steps(1,end)`,

    pointerEvents: expanded ? "auto" : "none",
  }}
  onMouseDown={onClose}
/>
      {/* ── Flyout panel ────────────────────────────────────────────────
          overflow:hidden clips content — height 0→67vh creates the slide
          zIndex 59 — above curtain, below header (60)
          background #fff + isolation block blur from showing through      */}
      <div
        ref={panelRef}
      style={{
  position: "absolute",
  top: "100%",
  marginTop: "-2px",

left: 0,

width: "calc(100% + 42px)",

  zIndex: 59,
  overflow: "hidden",

transform: expanded
  ? "translateY(0px) scaleY(1)"
  : "translateY(-10px) scaleY(0.96)",

transformOrigin: "top center",

opacity: expanded ? 1 : 0,

willChange: "transform, opacity",

transition: expanded
  ? `
      transform 0.42s ${APPLE_EASE_OUT},
      opacity 0.28s ease
    `
  : `
      transform 0.24s ${APPLE_EASE},
      opacity 0.18s ease
    `,

  borderRadius: "0 0 28px 28px",

  borderTop: "none",

  boxShadow: expanded
    ? "0 24px 48px rgba(0,0,0,0.14)"
    : "none",

  background: "#ffffff",

  isolation: "isolate",
}}
      >
        {/* Inner content — always full height inside clipping container */}
        <div style={innerPanel}>
          <div style={body}>

 
  {/* Col 1 — Search Suggestions */}
<section style={section}>

  <div style={sectionHeader}>
    <span style={sectionTitle}>
      {query.trim()
        ? "Search Results"
        : "Recent Searches"}
    </span>

    {!query.trim() && (
      <button style={seeAllBtn}>
        See all →
      </button>
    )}
  </div>

  {query.trim() ? (

    loading ? (

      <div
        style={{
          padding: "14px 10px",
          fontSize: 14,
          color: "#9ca3af",
        }}
      >
        Searching...
      </div>

    ) : results.length > 0 ? (

      results.map((item, i) => (
        <button
          key={i}
          style={recentRow}
          onClick={() =>
            window.location.href =
              `/product/${item._id}`
          }
        >

          <div
            style={{
              width: 46,
              height: 46,
              borderRadius: 10,
              overflow: "hidden",
              background: "#f3f4f6",
              flexShrink: 0,
            }}
          >
            {item.images?.[0] && (
              <img
          src={(() => {
  const img =
    item.variants?.find(v => v.condition === "used")?.images?.[0] ||
    item.variants?.find(v => v.condition === "new")?.images?.[0] ||
    item.images?.[0];
  return img?.startsWith("http") ? img : img ? `${API_URL}/${img}` : "";
})()}
                alt={item.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            )}
          </div>

          <div style={recentText}>
            <span style={recentQuery}>
              {item.title}
            </span>

            <span style={recentLoc}>
              {item.partNumber}
            </span>
          </div>

        </button>
      ))

    ) : (

      <div
        style={{
          padding: "14px 10px",
          fontSize: 14,
          color: "#9ca3af",
        }}
      >
        No results found
      </div>

    )

  ) : (

    RECENTS.map((r, i) => (
      <button
        key={i}
        style={recentRow}
        onClick={() => handleSearch(r.query)}
      >
        <div style={recentIconBox}>
          <svg
            viewBox="0 0 24 24"
            width="13"
            height="13"
            fill="none"
            stroke="#9ca3af"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <line
              x1="21"
              y1="21"
              x2="16.65"
              y2="16.65"
            />
          </svg>
        </div>

        <div style={recentText}>
          <span style={recentQuery}>
            {r.query}
          </span>

          <span style={recentLoc}>
            {r.location}
          </span>
        </div>

        <span style={recentDots}>
          ···
        </span>
      </button>
    ))

  )}

</section>



            {/* Col 2 — Find Nearby */}
            <section style={section}>
              <div style={sectionHeader}>
         <span style={sectionTitle}>Popular Categories</span>
              </div>
              <div style={nearbyGrid}>
          {NEARBY.map((n, i) => (
  <button
    key={i}
    style={nearbyCard}
    onClick={() => handleSearch(n.label)}
  >
    <span style={nearbyLabel}>
      {n.label}
    </span>
  </button>
))}
              </div>
            </section>

           {/* Col 3 — Featured Listings */}
<section style={{ ...section, borderRight: "none" }}>

  <div style={sectionHeader}>
    <span style={sectionTitle}>
      Featured Parts
    </span>

    <button style={seeAllBtn}>
      See all →
    </button>
  </div>

  <div style={servicesGrid}>

    {featuredListings.map((listing, i) => (

      <button
        key={listing._id || i}
        style={serviceCard}
        onClick={() =>
          window.location.href =
            `/product/${listing._id}`
        }
      >

       <div
  style={{
    width: 64,
    height: 64,
    flexShrink: 0,
    borderRadius: 10,
    overflow: "hidden",
    background: "#f3f4f6",
  }}
>
          {listing.images?.[0] && (
            <img

src={(() => {
  const img =
    listing.variants?.find(v => v.condition === "used")?.images?.[0] ||
    listing.variants?.find(v => v.condition === "new")?.images?.[0] ||
    listing.images?.[0];
  return img?.startsWith("http") ? img : img ? `${API_URL}/${img}` : "";
})()}

              alt={listing.title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )}
        </div>

        <div style={serviceInfo}>

          <span style={serviceTitle}>
            {listing.title}
          </span>

          <span style={serviceSub}>
            {listing.partNumber || "OEM Part"}
          </span>

        </div>

      </button>

    ))}

  </div>

</section>

          </div>
        </div>
      </div>
    </>
  );
}

/* ── styles ─────────────────────────────────────────────────────────── */

const innerPanel = {
  width: "100%",
  height: "460px",
  background: "#ffffff",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

const body = {
  flex: 1,

  display: "grid",

  gridTemplateColumns: "0.95fr 1.15fr 1fr",

  overflow: "hidden",
};

const section = {
  padding: "24px 28px",
  borderRight: "1px solid rgba(0,0,0,0.06)",
  overflowY: "auto",
};

const sectionHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 16,
};

const sectionTitle = {
  fontSize: 17,
  fontWeight: 700,
  color: "#0f172a",
  letterSpacing: "-0.01em",
};

const seeAllBtn = {
  background: "none",
  border: "none",
  cursor: "pointer",
  fontSize: 12.5,
  fontWeight: 500,
  color: BRAND,
  padding: 0,
  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",
};

const recentRow = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "9px 10px",
  borderRadius: 10,
  border: "none",
  background: "none",
  cursor: "pointer",
  width: "100%",
  textAlign: "left",
  transition: "background 0.15s ease",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",
};

const recentIconBox = {
  width: 30,
  height: 30,
  borderRadius: 8,
  background: "#f1f5f9",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const recentText = {
  display: "flex",
  flexDirection: "column",
  gap: 1,
  flex: 1,
};

const recentQuery  = { fontSize: 14, fontWeight: 600, color: "#0f172a" };
const recentLoc    = { fontSize: 11.5, color: "#9ca3af" };
const recentDots   = { fontSize: 15, color: "#d1d5db", letterSpacing: 1 };

const nearbyGrid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 10,
  width: "100%",
};


const nearbyCard = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  width: "100%",

  padding: "16px 14px",

  borderRadius: 14,
  border: "1px solid rgba(0,0,0,0.06)",

  background: "#ffffff",

  cursor: "pointer",
  textAlign: "center",

  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",

  transition: "transform 0.15s ease, box-shadow 0.15s ease",

  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",

  overflow: "hidden",
};

const nearbyLabel = {
  fontSize: 14,
  fontWeight: 700,
  color: "#0f172a",
  letterSpacing: "-0.01em",

  textAlign: "center",

  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};




const servicesGrid = {
  display: "flex",
  flexDirection: "column",
  gap: 10,
};

const serviceCard = {
  display: "flex",
  alignItems: "center",

  gap: 10,

  borderRadius: 14,

  border: "1px solid rgba(0,0,0,0.05)",

  overflow: "hidden",

  cursor: "pointer",

  background: "#fff",

padding: "10px 12px",

width: "100%",

  minHeight: "78px",

  boxShadow: "0 2px 10px rgba(0,0,0,0.04)",

  transition: "all 0.18s ease",

  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",
};


const serviceThumb = { width: "100%", height: 80, background: "rgba(0,0,0,0.07)" };



const serviceInfo = {
  flex: 1,

  display: "flex",
  flexDirection: "column",

  justifyContent: "center",

  gap: 3,

  minWidth: 0,
};


const serviceTitle = {
  fontSize: 12,
  fontWeight: 700,
  color: "#0f172a",

  lineHeight: "15px",

  overflow: "hidden",
  textOverflow: "ellipsis",

  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
};

const serviceSub = {
  fontSize: 10.5,
  color: "#9ca3af",

  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};